import { render, staticRenderFns } from "./bindMobile.vue?vue&type=template&id=b397c6f2"
import script from "./bindMobile.vue?vue&type=script&lang=js"
export * from "./bindMobile.vue?vue&type=script&lang=js"
import style0 from "./bindMobile.vue?vue&type=style&index=0&id=b397c6f2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports